module.exports = __webpack_public_path__ + "resources/img/img_seculetter_email_cloud_security_m_jp.a23b24cd75b2990d98591fdcb38791e1.png";